// extracted by mini-css-extract-plugin
module.exports = {"title":"StepHeading_title__3Gq6z","description":"StepHeading_description__3dEZt"};